import { all, fork } from 'redux-saga/effects'
import { initialUserInfoFlow, initialRegisterInfoFlow, refreshFlow, loginOutFlow } from './login'
import changeLanguageFlow from './i18n'

export default function* rootSaga() {
  yield all([fork(initialUserInfoFlow), fork(initialRegisterInfoFlow), fork(refreshFlow), fork(loginOutFlow), fork(changeLanguageFlow)])
}
